import auth from './auth/routes';
import batch from './batch/routes';
import compliance from './compliance/routes';
import credits from './credits/routes';
import dashboard from './dashboard/routes';
import history from './history/routes';
import invite from './invite/routes';
import metrics from './metrics/routes';
import recurrent from './recurrent/routes';
import status from './status/routes';
import template from './template/routes';

const routes = [
  ...auth,
  ...dashboard,
  ...compliance,
  ...template,
  ...history,
  ...credits,
  ...metrics,
  ...batch,
  ...invite,
  ...recurrent,
  ...status,
];

export default routes;
